import { Controller } from "@hotwired/stimulus"

// Keeps the signed-in case worker's own cards at the top of each column.
// The initial render already sorts them that way server-side (see
// _board.html.erb), but a card the board appends live afterward always
// lands at the column's end (see BroadcastBackofficeMove's `action:
// append`) — this re-applies the order whenever a column's contents change.
// Client-side for the same reason as card_dimming_controller.js:
// PolicyApplicationCardComponent broadcasts identically to every connected
// viewer, so "mine" can only be decided in each browser.
export default class extends Controller {
  static values = { currentUserId: String }

  connect() {
    this.observer = new MutationObserver(() => this.reorder())
    this.observer.observe(this.element, { childList: true, subtree: true })
    this.reorder()
  }

  disconnect() {
    this.observer.disconnect()
  }

  reorder() {
    // Moving cards below is itself a childList mutation — without this,
    // that would immediately re-trigger this same callback.
    this.observer.disconnect()

    this.element.querySelectorAll(".kanban__cards").forEach((column) => {
      const cards = Array.from(column.children)
      const mine = cards.filter((card) => card.dataset.caseWorkerId === this.currentUserIdValue)
      const others = cards.filter((card) => card.dataset.caseWorkerId !== this.currentUserIdValue)
      const ordered = [...mine, ...others]

      // appendChild always emits a mutation record, even for a node that's
      // already last — which used to retrigger kanban_search_controller's
      // own childList observer (it rewrites a count's textContent on every
      // trigger, itself a childList mutation) in an endless loop between the
      // two observers. Skip the column entirely once it's already in order.
      if (ordered.every((card, index) => card === cards[index])) return

      ordered.forEach((card) => column.appendChild(card))
    })

    this.observer.observe(this.element, { childList: true, subtree: true })
  }
}
